import { useEffect, useState } from "react";

const useFullscreenChange = (callback: (isFullscreen: boolean) => void) => {
  useEffect(() => {
    const handleFullscreenChange = () => {
      callback(document.fullscreenElement !== null);
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, [callback]);
};

export default useFullscreenChange;
